import React from "react";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

interface IconsBackgroundProps {
  width?: number;
  height?: number;
  borderRadius?: number;
  marginLeft?: number;
  marginRight?: number;
  className?: string;
  marginY?: number;
  sx?: SxProps<Theme>;
}

const IconsBackground: React.FC<IconsBackgroundProps> = ({
  width = 20,
  height = 20,
  borderRadius = 50,
  children,
  marginLeft,
  marginRight,
  className,
  marginY,
  sx,
}) => (
  <Box
    borderRadius={borderRadius}
    display="flex"
    alignItems="center"
    justifyContent="center"
    width={width}
    height={height}
    color="primary"
    ml={marginLeft}
    mr={marginRight}
    className={className}
    marginY={marginY}
    sx={{ backgroundColor: "#F7E64D", ...sx }}
  >
    {children}
  </Box>
);

export default IconsBackground;
